import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Network from '../../../models/Network.js';

import FilterListElement from '../list_elements/FilterListElement.js';
import LoadingListElement from '../list_elements/LoadingListElement.js';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const GpsGraphsModule = ({user, isSmallScreen}) => {

    const [jsonData, setJsonData] = useState(null);
    const [filterDict, setFilterDict] = useState(null);
    const [medicsData, setMedicsData] = useState(null);
    
    // function that gets multiple reports with GPS data from the server
    const getSeveralReportsGpsFiltered = async (desiredNumber, reportOffset, filterDict) => {
        
        const url = URLS.GET_SEVERAL_REPORTS_GPS_FILTERED;
        const dict = {
            uid: user.uid,
            number_of_reports: desiredNumber,
            offset: reportOffset,
            filter_dict: filterDict,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {

            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something

            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")

            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    }

    useEffect(() => {
        // Only load data when user has selected a date filter
        if (filterDict && (filterDict.lowerDate || filterDict.upperDate)) {
            getSeveralReportsGpsFiltered(5000, 0, filterDict)
                .then((data) => {
                    setJsonData(data);
                    console.log('Setting GPS JSON data:', data);
                })
                .catch((error) => {
                    console.log('Error:', error);
                });
        } else {
            // Clear data if no date filter is set
            setJsonData(null);
        }
    }, [filterDict]);

    const getAllAgencyMedics = async (agencyId) => {
        const url = URLS.GET_MEDICS_FOR_USER;
        const dict = {
            uid: user.uid,
            agency_id: agencyId,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    // get all medics from the server
    useEffect(() => {
        getAllAgencyMedics(user.uid)
            .then((data) => {
                setMedicsData(data);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    // Extract GPS data from report_object
    const extractGpsData = (reportObject) => {
        if (!reportObject) return null;
        
        try {
            const parsed = typeof reportObject === 'string' ? JSON.parse(reportObject) : reportObject;
            return {
                sceneGPSLocation: parsed.sceneGPSLocation || null,
                destinationGPSLocation: parsed.destinationGPSLocation || null
            };
        } catch (error) {
            console.error('Error parsing report_object:', error);
            return null;
        }
    };

    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <FilterListElement
                medicsData={medicsData}
                filterState={
                    {
                        date: [],
                        read: ["both"],
                        finished: ["both"]
                    }
                }
                dictUpdateHandler={setFilterDict}
                showClearButton={false}
                filterDropdownsVisible={{
                    date: true,
                    medics: true,
                    typeTags: true,
                }}
            />

            {!filterDict || (!filterDict.lowerDate && !filterDict.upperDate) ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h4 className='module-subtitle'>Select a date range above to visualize GPS data.</h4>
                </div>
            ) : jsonData === null ? (
                <LoadingListElement height={400} backgroundColor="white"/>
            ) : (
                <div style={{ padding: '20px' }}>
                    <h3 style={{ marginBottom: '20px' }}>GPS Data</h3>
                    {jsonData && jsonData.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            {jsonData.map((report, index) => {
                                const gpsData = extractGpsData(report.report_object);
                                return (
                                    <div 
                                        key={report.report_id || index} 
                                        style={{ 
                                            border: '1px solid #ddd', 
                                            borderRadius: '8px', 
                                            padding: '15px',
                                            backgroundColor: '#f9f9f9'
                                        }}
                                    >
                                        <div style={{ marginBottom: '10px' }}>
                                            <strong>Report ID:</strong> {report.report_id} | 
                                            <strong> PCR:</strong> {report.pcr_number || 'N/A'} | 
                                            <strong> Incident:</strong> {report.incident_number || 'N/A'} | 
                                            <strong> Created:</strong> {report.creation_timestamp ? new Date(report.creation_timestamp).toLocaleString() : 'N/A'}
                                        </div>
                                        {gpsData ? (
                                            <div style={{ fontFamily: 'monospace', fontSize: '12px', whiteSpace: 'pre-wrap' }}>
                                                <div><strong>Scene GPS Location:</strong> {gpsData.sceneGPSLocation ? JSON.stringify(gpsData.sceneGPSLocation, null, 2) : 'N/A'}</div>
                                                <div style={{ marginTop: '10px' }}><strong>Destination GPS Location:</strong> {gpsData.destinationGPSLocation ? JSON.stringify(gpsData.destinationGPSLocation, null, 2) : 'N/A'}</div>
                                            </div>
                                        ) : (
                                            <div style={{ color: '#999', fontStyle: 'italic' }}>No GPS data available in report_object</div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                            No GPS data found for the selected filters.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default GpsGraphsModule;

